export default "__VITE_ASSET__CLI5c_Pa__"